import { InframailOrder, InframailData } from '../types';

export function flattenOrdersForTable(
  orders: InframailOrder[],
): InframailData[] {
  return orders.flatMap((order) =>
    order.hosts.map((host) => ({
      orderId: order.id,
      status: order.status,
      createdBy: order.createdBy,
      ...host,
    })),
  );
}

export const createRowSpanMap = (
  data: InframailData[],
): Record<string, number> => {
  const orderIdToIds: Record<string, string[]> = {};
  const rowSpanMap: Record<string, number> = {};

  // Group row IDs by orderId
  data.forEach((row) => {
    if (!orderIdToIds[row.orderId]) {
      orderIdToIds[row.orderId] = [];
    }
    orderIdToIds[row.orderId].push(row.id);
  });

  // Assign rowSpan only to first row in each group
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Object.entries(orderIdToIds).forEach(([_orderId, ids]) => {
    const span = ids.length;
    ids.forEach((id, index) => {
      rowSpanMap[id] = index === 0 ? span : 0;
    });
  });

  return rowSpanMap;
};
